module.exports = __webpack_public_path__ + "img/pantalla-4-1.a2eebbed.png";